module.exports = __webpack_public_path__ + "bb391f08c9b389b9784b94946f39c140.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/img/sprite_benefits_thumb.png
// module id = 287
// module chunks = 0